import React, {useEffect, useRef, useState} from 'react';
import icSearch from '../../../images/ic_search.png';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Loading from '../../../common/components/Loading/Loading';
import actions from '../../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TableHeader from '../../../common/components/ItemTable/TableHeader';
import TableRow from '../../../common/components/ItemTable/TableRow';
import {Tooltip} from '@mui/material';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import moment from 'moment/moment';
import Modal from '../../../common/components/Modal/Modal';
// import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';
import TablePaginator from '../../../common/components/TablePaginator/TablePaginator';
import Chip from '../../../common/components/Chip/Chip';
import _ from 'lodash';
import {useHistory} from 'react-router-dom';
import ExcelDownloadButton from '../../../common/components/ExcelDownloadButton/ExcelDownloadButton';

const AttentionsList = (props) => {
    const {
        name,
        title,
        switchOfUser,
        getAllAttentions,
        allAttentions,
        getAllAttentionsState,
        getAllAttentionsToDownload,
        role,
        deleteAttention,
        attentionsListConfig,
        setListConfig,
        getMedicalServices,
        selectPlan,
        cleanListConfig,
        showSidebar,
        attentionsToDownload,
    } = props;
    const history = useHistory();

    const tooltip = (attention) => {
        return (
            <Tooltip title={attention.numbers}>
                <text>{attention.affiliateFullName}</text>
            </Tooltip>
        );
    };

    const tooltipCode = (attention) => {
        return (
            <Tooltip title={`CODIGO: ${attention.medicalServiceCode}`}>
                <text>{attention.medicalServiceName}</text>
            </Tooltip>
        );
    };

    const amount = (attention) => {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginRight: 20,
                marginLeft: 10,
            }}>
                <text>{attention.amountPaid}</text>
                {/* {attention.observations === 'manualFee' && <NoteAltIcon/>} */}
            </div>
        );
    };


    const deleteAttentionBtn = (attention) => {
        const canCancel = checkIfCanCancelAttention(attention.createdDate);
        return (canCancel &&
            <Ebutton classNameButton=""
                     onClick={() => {
                         handleDelete(attention);
                     }}
                     text="X"
                     tooltipText='Cancelar atención'
                     disabled={!canCancel}
            />
        );
    };

    const checkIfCanCancelAttention = (createdDate) => {
        const now = moment(Date.now());
        const month = 1 + moment(createdDate).month();
        const year = moment(createdDate).year();
        const day = moment(createdDate).day();
        const actualMonth = 1 + now.month();
        const actualYear = now.year();
        const actualDay = now.day();
        const diffDay = actualDay - day;
        const diffYears = actualYear - year;
        const diffMonth = actualMonth - month;
        // if (diffYears > 1) return false;
        // if (diffYears === 0 && diffMonth === 0) {
        //     return true;
        // }
        // if (diffYears === 1 && month === 12 && actualMonth === 1 && actualDay <= 15) {
        //     return true;
        // }
        // if (diffYears === 0 && diffMonth === 1 && actualDay <= 15) {
        //     return true;
        // }
        return moment(createdDate).isSame(Date.now(), 'day');
    };

    const [showModal, setShowModal] = useState(false);
    const [modalButtonAction, setModalButtonAction] = useState(null);
    const [modalText, setModalText] = useState('');
    const [search, setSearch] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [items, setItems] = useState([]);
    const [dataToDownload, setDataToDownload] = useState([]);
    const [listData, setListData] = useState([]);
    const tagNames = {
        medicalServiceName: 'ATENCIÓN',
        // medicalServiceCode: 'CÓDIGO NOMENCLADOR',
        // affiliateName: 'NOMBRE DE AFILIADO',
        affiliateLastName: 'AFILIADO',
        affiliateDocument: 'DOCUMENTO DE AFILIADO',
        providerAddress: 'SEDE',
        providerName: 'PRESTADOR',
        dateFrom: 'FECHA DESDE',
        dateTo: 'FECHA HASTA',
        planName: 'PLAN',
        lastWeek: 'ULTIMA SEMANA',
        lastMounth: 'ULTIMO MES',
    };
    const [currentPage, setCurrentPage] = useState(-1);

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [pageQuantity, setPageQuantity] = useState(Math.ceil(allAttentions?.totalCount));


    // const pageQuantity = ;

    const isInitialMount = useRef(true);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleDelete = (attention) => {
        setModalButtonAction(() => () => handleClickDelete(attention));
        setModalText('¿SEGURO QUE DESEA CANCELAR ESTA ATENCIÓN?');
        setShowModal(true);
    };

    const handleClickDelete = (attention) => {
        const body = {
            attentionId: attention.attentionId,
        };
        deleteAttention(body);
        handleClose();
    };

    const restarUnaSemana = (fechaActual) => {
        const nuevaFecha = new Date(fechaActual);

        nuevaFecha.setDate(nuevaFecha.getDate() - 7);

        const año = nuevaFecha.getFullYear();
        const mes = (nuevaFecha.getMonth() + 1).toString().padStart(2, '0');
        const dia = nuevaFecha.getDate().toString().padStart(2, '0');
        const fechaFormateada = `${año}-${mes}-${dia}`;

        return fechaFormateada;
    };

    const restarMes = (fecha) => {
        const nuevaFecha = new Date(fecha);

        let nuevoMes = nuevaFecha.getMonth() - 1;

        if (nuevoMes < 0) {
            nuevaFecha.setFullYear(nuevaFecha.getFullYear() - 1); // Restar un año
            nuevoMes = 11; // Diciembre es el mes 11
        }

        nuevaFecha.setMonth(nuevoMes);

        const año = nuevaFecha.getFullYear();
        const mes = (nuevaFecha.getMonth() + 1).toString().padStart(2, '0');
        const dia = nuevaFecha.getDate().toString().padStart(2, '0');
        const fechaFormateada = `${año}-${mes}-${dia}`;

        return fechaFormateada;
    };

    const handleSearch = () => {
        if (searchTag === 'lastWeek') {
            const searchTags = {...attentionsListConfig.searchTags, ['dateFrom']: restarUnaSemana(new Date())};

            setListConfig({
                list: 'attentionsListConfig',
                config: {search: restarUnaSemana(new Date()), searchTags, page: 1, size: rowsPerPage},
            });

            getAllAttentions();
            getAllAttentionsToDownload();

            setSearch('');
        } else if (searchTag === 'lastMounth') {
            const searchTags = {...attentionsListConfig.searchTags, ['dateFrom']: restarMes(new Date())};

            setListConfig({
                list: 'attentionsListConfig',
                config: {search: restarUnaSemana(new Date()), searchTags, page: 1, size: rowsPerPage},
            });

            getAllAttentions();
            getAllAttentionsToDownload();

            setSearch('');
        } else {
            const searchTags = {...attentionsListConfig.searchTags, [searchTag || 'medicalServiceName']: search};

            setListConfig({
                list: 'attentionsListConfig',
                config: {search: search, searchTags, page: 1, size: rowsPerPage},
            });
            getAllAttentions();
            getAllAttentionsToDownload();

            setSearch('');
        }
    };

    const openPlan = (plan, getMedicalServices) => {
        return (
            <p className="ul-plan"
               onClick={() => {
                   switchOfUser('Planes');
                   selectPlan(plan.planName);
                   setListConfig({
                       list: 'medicalServicesListConfig',
                       config: {page: 1, size: rowsPerPage, orderBy: [], searchTags: {}},
                   });
                   history.push('plans/medicalServices');
               }}
            >{plan.planName}</p>
        );
    };

    useEffect(() => {
        switchOfUser('Historial atenciones');
        cleanListConfig('attentionsListConfig');
        setCurrentPage(1);
        getAllAttentionsToDownload();
        switch (role) {
            case 'PROVIDER_ADMIN':
                setListData([
                    {title: 'NOMBRE', att: 'name', width: '10%'},
                    {title: 'ATENCIÓN', component: (attention) => tooltipCode(attention), width: '10%', sort: true},
                    {title: 'FECHA', att: 'createdDate', width: '10%', isDate: true, sort: true},
                    {title: 'MODALIDAD', att: 'modality', width: '10%', centerTitle: true},
                    {title: 'MONTO', component: (attention) => amount(attention), width: '10%'},
                    // {title: 'CÓDIGO', att: 'medicalServiceCode', width: '10%', sort: true},
                    {
                        title: 'AFILIADO',
                        sortProp: 'affiliateFullName',
                        component: (attention) => tooltip(attention),
                        width: '10%',
                        sort: true,
                    },
                    {title: 'SEDE', att: 'branchAddress', width: '10%', sort: true},
                    {
                        title: 'PLAN',
                        component: (plan) => openPlan(plan, getMedicalServices),
                        width: '10%',
                        sort: true,
                        sortProp: 'planName',
                    },
                    {title: '', component: (attention) => deleteAttentionBtn(attention), width: '10%'},
                ]);
                break;
            case 'ADMIN':
                setListData([
                    {title: 'NOMBRE', att: 'name', width: '10%'},
                    {title: 'ATENCIÓN', component: (attention) => tooltipCode(attention), width: '10%', sort: true},
                    {title: 'FECHA', att: 'createdDate', width: '10%', isDate: true, sort: true},
                    {title: 'MODALIDAD', att: 'modality', width: '5%', centerTitle: true},
                    {title: 'MONTO', component: (attention) => amount(attention), width: '10%', centerTitle: true},
                    // {title: 'CÓDIGO', att: 'medicalServiceCode', width: '10%', sort: true},
                    {
                        title: 'AFILIADO',
                        sortProp: 'affiliateFullName',
                        component: (attention) => tooltip(attention),
                        width: '15%',
                        sort: true,
                    },
                    {title: 'PRESTADOR', att: 'providerName', width: '15%', sort: true},
                    {title: 'SEDE', att: 'branchAddress', width: '10%', sort: true},
                    {
                        title: 'PLAN',
                        component: (plan) => openPlan(plan, getMedicalServices),
                        width: '15%',
                        sort: true,
                        sortProp: 'planName',
                    },
                    {title: '', component: (attention) => deleteAttentionBtn(attention), width: '10%'},
                ]);
                break;
            default:
                setListData([
                    {title: 'NOMBRE', att: 'name', width: '10%'},
                    {title: 'ATENCIÓN', component: (attention) => tooltipCode(attention), width: '10%', sort: true},
                    {title: 'FECHA', att: 'createdDate', width: '10%', isDate: true, sort: true},
                    {title: 'MODALIDAD', att: 'modality', width: '10%'},
                    // {title: 'MONTO', component: (attention) => amount(attention), width: '10%'},
                    // {title: 'CÓDIGO', att: 'medicalServiceCode', width: '10%', sort: true},
                    {
                        title: 'AFILIADO',
                        sortProp: 'affiliateFullName',
                        component: (attention) => tooltip(attention),
                        width: '15%',
                        sort: true,
                    },
                    {
                        title: 'PLAN',
                        component: (plan) => openPlan(plan, getMedicalServices),
                        width: '15%',
                        sort: true,
                        sortProp: 'planName',
                    },
                    {title: '', component: (attention) => deleteAttentionBtn(attention), width: '10%'},
                ]);
                break;
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isInitialMount.current || attentionsListConfig === undefined) {
            setListConfig({
                list: 'attentionsListConfig',
                config: {page: currentPage, size: rowsPerPage},
            });
            getAllAttentions();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage, rowsPerPage]);

    useEffect(() => {
        if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
        setPageQuantity(Math.ceil(allAttentions?.totalCount));
        // eslint-disable-next-line
    }, [allAttentions]);

    useEffect(() => {
        setItems(allAttentions);
        setPageQuantity(Math.ceil(allAttentions?.totalCount));
    }, [allAttentions, getAllAttentionsState.success]);

    const deleteSearchTag = (tag) => {
        const searchTags = _.omit(attentionsListConfig?.searchTags, [tag]);

        setListConfig({
            list: 'attentionsListConfig',
            config: {search: search, searchTags},
        });
        getAllAttentions();
    };

    const sortList = (param) => {
        const element = attentionsListConfig?.orderBy?.find((e) => e?.param === param);
        const newElement = {
            param,
            ord: element?.ord === 'asc' ? 'desc' : 'asc',
        };
        const orderBy = [newElement];

        setListConfig({
            list: 'attentionsListConfig',
            config: {orderBy},
        });

        getAllAttentions();
    };

    const headers = [['ID_ATENCIÓN', 'ID_SERVICIO_MEDICO', 'ID_SEDE_PRESTADOR',
        'ID_AFILIADO', 'MONTO', 'OBSERVACIONES', 'FECHA_DE_CREACIÓN', 'COPAGO',
        'NOMBRE', 'NOMBRE_SERVICIO_MEDICO', 'CODIGO_SERVICIO_MÉDICO', 'DIRECCIÓN_SEDE',
        'NOMBRE_PRESTADOR', 'MODALIDAD', 'NOMBRE_PLAN', 'CREDENCIALES', 'NOMBRE_AFILIADO', 'DOCUMENTO_AFILIADO', 'NÚMERO_AFILIADO']];

    useEffect(() => {
        setDataToDownload(attentionsToDownload);
    }, [attentionsToDownload]);

    useEffect(() => {
        if (searchTag === 'lastWeek' || searchTag === 'lastMounth') {
            handleSearch();
        }
    }, [searchTag]);

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>

            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                    <div>
                        {dataToDownload.length > 0 ?
                            <ExcelDownloadButton data={dataToDownload} headers={headers}
                                                 fileName={`ATENCIONES:${role === 'ADMIN' ? 'TODAS' : name}-
                                                 FECHA DE EMISION:${new Date().toLocaleDateString()}`}/> :
                            <Ebutton classNameButton={'disabled'} disabled={true} text={'CARGANDO...'}/>
                        }
                    </div>
                    <div>
                        <form onSubmit={(event) => {
                            handleSearch();
                            event.preventDefault();
                        }}>
                            <div className="ul-div-serchCont">
                                <hr className={'ul-hr'}/>
                                <div className="ul-div-tagSel">
                                    <select
                                        style={{width: '240px'}}
                                        className="ul-div-searchbar"
                                        onChange={(e) => setSearchTag(e.target.value)}
                                        defaultValue={'medicalServiceName'}
                                    >
                                        <option value={'medicalServiceName'}
                                                selected="selected">{tagNames['medicalServiceName']}</option>
                                        <option value={'lastWeek'}>{tagNames['lastWeek']}</option>
                                        <option value={'lastMounth'}>{tagNames['lastMounth']}</option>
                                        {/* <option value={'medicalServiceCode'} >{tagNames['medicalServiceCode']}</option> */}
                                        {/* <option value={'affiliateName'} >{tagNames['affiliateName']}</option> */}
                                        <option value={'affiliateLastName'}>{tagNames['affiliateLastName']}</option>
                                        <option value={'affiliateDocument'}>{tagNames['affiliateDocument']}</option>
                                        {['PROVIDER_ADMIN', 'ADMIN'].includes(role) &&
                                            <option value={'providerAddress'}>{tagNames['providerAddress']}</option>}
                                        {role === 'ADMIN' &&
                                            <option value={'providerName'}>{tagNames['providerName']}</option>}
                                        <option value={'dateFrom'}>{tagNames['dateFrom']}</option>
                                        <option value={'dateTo'}>{tagNames['dateTo']}</option>
                                        {/* <option value={'planName'} >{tagNames['planName']}</option> */}
                                    </select>
                                </div>
                                <div className="ul-div-searchbar">
                                    <input
                                        placeholder="Buscar atención"
                                        type={searchTag === 'dateFrom' || searchTag === 'dateTo' ? 'date' : 'text'}
                                        value={search}
                                        onChange={(e) => {
                                            setSearch(searchTag === 'dateFrom' || searchTag === 'dateTo' ?
                                                e.target.value.replace(/[^\w\s-/]/gi, '').toString() :
                                                e.target.value.replace(/[^\w\s]/gi, '').toString());
                                        }}
                                    />
                                    <button type='submit'><img src={icSearch} alt={'search'}/></button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div>
                    {attentionsListConfig?.searchTags && Object.keys(attentionsListConfig?.searchTags).map((key) =>
                        <Chip
                            key={key}
                            text={tagNames[key] + ': ' + attentionsListConfig?.searchTags[key]}
                            event={() => {
                                deleteSearchTag(key);
                            }}
                        />,
                    )
                    }
                </div>
                <div className="ul-div-sect-table">
                    {getAllAttentionsState.success ?
                        <table className="ul-div-table">
                            <TableHeader listData={listData} sortList={sortList}
                                         sortParam={attentionsListConfig.orderBy}/>
                            <tbody>
                            {
                                items?.length <= 0 ?
                                    <tr>
                                        <td colSpan={100}><CustomAlert text='atenciones'/></td>
                                    </tr> :
                                    items?.map((item, index) =>
                                        <TableRow key={index} listData={listData} data={item}/>,
                                    )
                            }
                            </tbody>
                        </table> :
                        getAllAttentionsState.loading ? <Loading className="ul-div-sect-table"/> :
                            <CustomAlert text={'atenciones' || String(getAllAttentionsState.error)} severity='error'/>
                    }
                    <div className="ul-div-bottom">
                        <TablePaginator
                            pageQuantity={pageQuantity}
                            currentPage={attentionsListConfig.page}
                            setCurrentPage={setCurrentPage}
                            initInOne={true}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {showModal && (
                    <Modal
                        showModal={showModal}
                        handleClose={handleClose}
                        handleClick={modalButtonAction}
                        modalText={modalText}
                    />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    allAttentions: state.home.allAttentions,
    getAllAttentionsState: state.home.getAllAttentionsState,
    attentionsListConfig: state.home.attentionsListConfig,
    role: state.login.userInfo.role.name,
    showSidebar: state.common.showSidebar,
    attentionsToDownload: state.home.attentionsToDownload,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getAllAttentions: () => dispatch(actions.home.getAllAttentionsRequest()),
    getAllAttentionsToDownload: () => dispatch(actions.home.getAllAttentionsDownloadRequest()),
    deleteAttention: (body) => dispatch(actions.home.deleteAttentionRequest(body)),
    getMedicalServices: (plans) => dispatch(actions.home.getMedicalServicesRequest(plans)),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    selectPlan: (plan) => dispatch(actions.home.selectPlan(plan)),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
});

AttentionsList.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    allAttentions: PropTypes.array,
    getAllAttentionsState: PropTypes.object,
    attentionsToDownload: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttentionsList);

